// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import '../../i18n/fr-BE';

import error from './error';

error();
